import React from 'react';
import Button from './Button';
import {
  createCalendar,
  CalendarDayContext,
  CalendarDateRange,
} from '../../../../../../../client/components/BubbleUI/abstracts/Calendar';

// Re-export shared types under the names callers already use
export type { CalendarDateRange };
export type { CalendarDayContext };

export default createCalendar({
  className: 'bg-white',
  titleClassName: 'text-accent',
  daysClassName: 'text-secondary',
  NavButton: ({ direction, onClick }) => (
    <Button
      size="small"
      icon={direction === 'prev' ? ['fass', 'arrow-left'] : ['fass', 'arrow-right']}
      onClick={onClick}
      variant="accent"
      className="border-none-i"
      inverse
    />
  ),
  DayButton: ({ day, dayContext, onClick }) => {
    const { isHighlighted, isCurrentDate, isOutOfBounds } = dayContext;

    return (
      <Button
        variant={
          isHighlighted
            ? 'active'
            : isCurrentDate
              ? 'emphasis'
              : isOutOfBounds
                ? 'borderlike'
                : 'secondary'
        }
        inverse={!isHighlighted}
        onClick={onClick}
        className="p-0-i border-none-i rounded-full-i flex items-center justify-center"
        style={{ width: '35px', height: '35px' }}
      >
        <span className={isCurrentDate ? 'font-bold' : 'font-normal'}>{Math.abs(day)}</span>
      </Button>
    );
  },
  Badge: ({ color }) => (
    <div style={{ backgroundColor: color, width: '5px', height: '5px', borderRadius: '100%' }} />
  ),
  TodayButton: ({ onClick }) => (
    <Button size="small" variant="accent" inverse className="border-none-i" onClick={onClick}>
      Today
    </Button>
  ),
  ClearButton: ({ onClick }) => (
    <Button size="small" variant="muted" inverse className="border-none-i" onClick={onClick}>
      Clear
    </Button>
  ),
});
